export type ThemeMode = 'auto' | 'light' | 'dark';
export type ResolvedTheme = 'light' | 'dark';

export const THEME_MODE_STORAGE_KEY = 'callhub.theme.mode';

export function normalizeThemeMode(value: string | null | undefined): ThemeMode {
  if (value === 'light' || value === 'dark' || value === 'auto') return value;
  return 'auto';
}

export function getSystemPrefersDark(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

export function resolveTheme(mode: ThemeMode, systemPrefersDark: boolean): ResolvedTheme {
  if (mode === 'auto') {
    return systemPrefersDark ? 'dark' : 'light';
  }
  return mode;
}

export function getStoredThemeMode(): ThemeMode {
  if (typeof window === 'undefined') return 'auto';
  return normalizeThemeMode(window.localStorage.getItem(THEME_MODE_STORAGE_KEY));
}

export function setStoredThemeMode(mode: ThemeMode) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(THEME_MODE_STORAGE_KEY, mode);
}

export function applyResolvedTheme(theme: ResolvedTheme) {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  root.classList.toggle('dark', theme === 'dark');
  root.setAttribute('data-theme', theme);
}

export function initializeDocumentTheme() {
  const mode = getStoredThemeMode();
  const theme = resolveTheme(mode, getSystemPrefersDark());
  applyResolvedTheme(theme);
  return { mode, theme };
}
